import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

// Components
import IconButton from '../../atoms/IconButton/IconButton';
import Picto from '../../atoms/Picto/Picto';

// Utils
import cn from '../../../utils/cn';

// Styles
import styles from './RowBatchCard.module.css';

/**
 * RowBatchCard - Draggable card component for individual batch row actions
 * @param {object} props
 * @param {number | string} props.id
 * @param {import('react').ReactNode | null} [props.headerRight] - Header right content
 * @param {import('react').ReactNode} [props.children] - Card content
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element} RowBatchCard component
 */
function RowBatchCard({
  id,
  children,
  className,
  headerRight = null,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
  });

  return (
    <div
      className={cn([styles.card, className])}
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
        transition,
        zIndex: isDragging ? 2 : 'auto',
      }}
    >
      <div className={styles.header}>
        <div className={styles['header-left']}>
          <IconButton
            icon="drag-horizontal"
            color="transparent"
            size="medium"
            className={styles['drag-handle']}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...attributes}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...listeners}
          >
            <Picto icon="drag-horizontal" className={styles['drag-icon']} />
          </IconButton>
        </div>
        <div className={styles['header-right']}>
          {headerRight}
        </div>
      </div>

      {children && (
        <div className={styles.content}>
          {children}
        </div>
      )}
    </div>
  );
}

export default RowBatchCard;
